import React from 'react'
import { cn } from '../../utils/cn'

export interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  isLoaded?: boolean
}

export const Skeleton = React.forwardRef<HTMLDivElement, SkeletonProps>(
  ({ className, isLoaded, children, ...props }, ref) => {
    if (isLoaded) return <>{children}</>
    return (
      <div
        ref={ref}
        data-slot="skeleton"
        className={cn('animate-pulse rounded-md bg-surface-subtle', className)}
        {...props}
      />
    )
  },
)
Skeleton.displayName = 'Skeleton'

export const SkeletonText = ({
  noOfLines = 3,
  className,
}: {
  noOfLines?: number
  className?: string
}) => (
  <div className={cn('flex flex-col gap-2', className)}>
    {Array.from({ length: noOfLines }).map((_, i) => (
      <Skeleton key={i} className={cn('h-3 w-full', i === noOfLines - 1 && 'w-4/5')} />
    ))}
  </div>
)

export const SkeletonCircle = ({
  size = '40px',
  className,
}: {
  size?: string
  className?: string
}) => <Skeleton className={cn('rounded-full', className)} style={{ width: size, height: size }} />
